const GenericErrorMessage = ({ errorMessage }) => (
  <div className='error_details_wrapper'>
    <div className='error_item' dangerouslySetInnerHTML={{ __html: errorMessage }} />
  </div>
)
// Export the component for use.
export default GenericErrorMessage
